import { getDecorativeHorizontalStyles } from './variantStyles/decorativeHorizontal';
import { getDecorativeVerticalStyles } from './variantStyles/decorativeVertical';
import { getDefaultHorizontalStyles } from './variantStyles/defaultHorizontal';
import { getDefaultVerticalStyles } from './variantStyles/defaultVertical';
import { getMainSectionHorizontalStyles } from './variantStyles/mainSectionHorizontal';
import { getMainSectionVerticalStyles } from './variantStyles/mainSectionVertical';
import { getRegularHorizontalStyles } from './variantStyles/regularHorizontal';
import { getRegularVerticalStyles } from './variantStyles/regularVertical';
import { LineSeparatorLabelVariantType } from './variants';
export const getLineSeparatorStyles = (FOUNDATIONS, FONT) => {
    return {
        [LineSeparatorLabelVariantType.LABEL_DEFAULT]: {},
        ...getDefaultHorizontalStyles(FOUNDATIONS, FONT),
        ...getDefaultVerticalStyles(FOUNDATIONS, FONT),
        ...getRegularHorizontalStyles(FOUNDATIONS, FONT),
        ...getRegularVerticalStyles(FOUNDATIONS, FONT),
        ...getMainSectionHorizontalStyles(FOUNDATIONS, FONT),
        ...getMainSectionVerticalStyles(FOUNDATIONS, FONT),
        ...getDecorativeHorizontalStyles(FOUNDATIONS, FONT),
        ...getDecorativeVerticalStyles(FOUNDATIONS, FONT),
    };
};
//# sourceMappingURL=styles.js.map